import { z } from "zod";

export const kSearchDefaultLimit = 8;
export const kSearchDefaultChorePageSize = 20;
export const kSearchMaxLimit = 50;

export const searchSchema = z.object({
  query: z.string(),
  limit: z.number().int().min(1).max(kSearchMaxLimit).optional(),
  chorePage: z.number().int().min(1).optional(),
  chorePageSize: z.number().int().min(1).max(kSearchMaxLimit).optional(),
});

export type SearchArgs = z.infer<typeof searchSchema>;

export interface ISearchWorkspaceResult {
  id: string;
  name: string;
}

export interface ISearchListResult {
  id: string;
  name: string;
  workspaceId: string | null;
  workspaceName: string | null;
}

export interface ISearchChoreResult {
  id: string;
  title: string;
  listId: string;
  listName: string;
  workspaceId: string | null;
  workspaceName: string | null;
}

export interface ISearchEndpointResponse {
  workspaces: ISearchWorkspaceResult[];
  lists: ISearchListResult[];
  chores: ISearchChoreResult[];
  choresHasMore: boolean;
}
